import { render, staticRenderFns } from "./log-view.vue?vue&type=template&id=0cc48980&scoped=true&"
import script from "./log-view.vue?vue&type=script&lang=js&"
export * from "./log-view.vue?vue&type=script&lang=js&"
import style0 from "./log-view.vue?vue&type=style&index=0&id=0cc48980&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc48980",
  null
  
)

export default component.exports